import ProductCard from "./ProductCard";
import { type RootState } from "../../../redux/store";

interface ExpandedContentProps {
  marketPlace: {
    marketPlace: string;
  };
  row: {
    original?: {
      product_id?: string;
    };
  };
  user: RootState["user"];
  channel: string;
}

export const ExpandedContent = ({ marketPlace, row, user, channel }: ExpandedContentProps) => {
  return (
    <ProductCard
      marketPlace={marketPlace}
      productId={row.original?.product_id}
      user={user}
      channel={channel}
      additionalTabs={null}
      initialTab={null}
      hasBorder={false}
    />
  );
};
